import React from "react";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import PausedSubscriptionImage from "public/assets/coco-whatsapp.svg";
import {
  ButtonGroup,
  PausedContainer,
  PausedImage,
  PausedTextWrapper,
  TextDesc,
  TextTitle
} from "./practice-subscription-paused.styles";

interface PracticeSubscriptionPausedProps {
  onClose: () => void;
}

export const PracticeSubscriptionPaused: React.FC<
  PracticeSubscriptionPausedProps
> = ({ onClose }) => {
  return (
    <PausedContainer>
      <PausedImage
        src={PausedSubscriptionImage}
        alt="CoLearn akan mengirimkan informasi pembayaran melalui WhatsApp"
      />

      <PausedTextWrapper>
        <TextTitle>Lakukan pembayaran buat lanjut ikut Latihan</TextTitle>
        <TextDesc>
          Linknya dikirim CoLearn (+6281119103012) ke WA orangtuamu saat jatuh
          tempo
        </TextDesc>
      </PausedTextWrapper>

      <ButtonGroup>
        <Button
          appearance="general"
          variant="primary"
          size={ButtonSize.lg}
          isFullWidth
          onClick={onClose}
        >
          Oke, mengerti
        </Button>
      </ButtonGroup>
    </PausedContainer>
  );
};
